import { For } from "solid-js";
import { useI18n } from "@/api/i18n";
import { cn } from "@/libs/cn";
import { REFINE_STEPS } from "../constants";
import { useRefineStore } from "../store/RefineProvider";
import type { RefineStepId } from "../types";

type RefineStepperProps = {
  onStepClick: (stepId: RefineStepId) => void;
};

export function RefineStepper(props: RefineStepperProps) {
  const { t } = useI18n();
  const { state } = useRefineStore();

  return (
    <nav class="flex items-center gap-0 overflow-x-auto">
      <For each={REFINE_STEPS}>
        {(step, index) => {
          const isActive = () => state.currentStep === step.id;
          const isCompleted = () => state.completedSteps.includes(step.id);

          return (
            <>
              {index() > 0 && (
                <div
                  class={cn(
                    "h-px flex-1 min-w-6 transition-colors",
                    isCompleted() ? "bg-matisse-500" : "bg-border",
                  )}
                />
              )}
              <button
                type="button"
                class="flex items-center gap-2 shrink-0 text-sm transition-colors py-1 cursor-pointer"
                onClick={() => props.onStepClick(step.id)}
              >
                <div
                  class={cn(
                    "flex h-7 w-7 items-center justify-center rounded-full text-xs font-medium transition-[color,background-color,border-color,box-shadow]",
                    isCompleted() && !isActive() && "bg-matisse-500 text-white",
                    isActive() &&
                      "bg-matisse-500 text-white ring-2 ring-matisse-200",
                    !isActive() &&
                      !isCompleted() &&
                      "border border-border bg-background text-muted-foreground",
                  )}
                >
                  {isCompleted() && !isActive() ? (
                    <i class="ph ph-check text-sm font-bold" />
                  ) : (
                    step.id
                  )}
                </div>
                <span
                  class={cn(
                    "hidden sm:inline text-sm",
                    isActive() && "font-medium text-foreground",
                    isCompleted() && !isActive() && "text-foreground",
                    !isActive() && !isCompleted() && "text-muted-foreground",
                  )}
                >
                  {t(step.title) as string}
                </span>
              </button>
            </>
          );
        }}
      </For>
    </nav>
  );
}
